/* TYPES REDUX */



// Background
export const SHOW_BACKGROUND_VIDEO = 'SHOW_BACKGROUND_VIDEO'

// General
export const DOWNLOAD_GENERAL_DATA = 'DOWNLOAD_GENERAL_DATA'
export const SUCCESS_DOWNLOAD_GENERAL_DATA = 'SUCCESS_DOWNLOAD_GENERAL_DATA'
export const ERROR_DOWNLOAD_GENERAL_DATA = 'ERROR_DOWNLOAD_GENERAL_DATA'
export const PLAY_SOUND = 'PLAY_SOUND'
export const SHOW_LOADER = 'SHOW_LOADER'
export const SET_CURRENT_OFFERING = 'SET_CURRENT_OFFERING'

// Home
export const DOWNLOAD_HOME_DATA = 'DOWNLOAD_HOME_DATA'
export const SUCCESS_DOWNLOAD_HOME_DATA = 'SUCCESS_DOWNLOAD_HOME_DATA'
export const ERROR_DOWNLOAD_HOME_DATA = 'ERROR_DOWNLOAD_HOME_DATA'

// Register
export const REGISTER_USER = 'REGISTER_USER'
export const SUCCESS_REGISTER_USER = 'SUCCESS_REGISTER_USER'
export const ERROR_REGISTER_USER = 'ERROR_REGISTER_USER'

// Offerings
export const DOWNLOAD_CURRENT_OFFERING = 'DOWNLOAD_CURRENT_OFFERING'
export const SUCCESS_DOWNLOAD_CURRENT_OFFERING = 'SUCCESS_DOWNLOAD_CURRENT_OFFERING'
export const ERROR_DOWNLOAD_CURRENT_OFFERING = 'ERROR_DOWNLOAD_OFFERINGS_DATA'

// Create Offering
export const DOWNLOAD_CREATOR_OFFERING_DATA = 'DOWNLOAD_CREATOR_OFFERING_DATA'
export const SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA = 'SUCCESS_DOWNLOAD_CREATOR_OFFERING_DATA'
export const ERROR_DOWNLOAD_CREATOR_OFFERING_DATA = 'ERROR_DOWNLOAD_CREATOR_OFFERING_DATA'
export const SEND_OFFERING = 'SEND_OFFERING'
export const SUCCESS_SEND_OFFERING = 'SUCCESS_SEND_OFFERING'
export const ERROR_SEND_OFFERING = 'ERROR_SEND_OFFERING'
export const UPDATE_TEMPORAL_IMAGE = 'UPDATE_TEMPORAL_IMAGE'
export const UPDATE_CONFIRMED_IMAGE = 'UPDATE_CONFIRMED_IMAGE'
export const SHOW_CUTTER_IMAGE = 'SHOW_CUTTER_IMAGE'


// Modal
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const SET_DATA_MODAL = 'SET_DATA_MODAL'

// Terms
export const DOWNLOAD_TERMS_DATA = 'DOWNLOAD_TERMS_DATA'
export const SUCCESS_DOWNLOAD_TERMS_DATA = 'SUCCESS_DOWNLOAD_TERMS_DATA'
export const ERROR_DOWNLOAD_TERMS_DATA = 'ERROR_DOWNLOAD_TERMS_DATA'
